import React, { useState } from "react";
import axiosInstance from "../utils/api";


export default function AddItemForm({ endpoint, fields, successMessage }) {
  const initial = {};
  fields.forEach((f) => (initial[f.name] = f.type === "file" ? null : ""));

  const [form, setForm] = useState(initial);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e, name, type) => {
    if (type === "file") {
      const file = e.target.files[0];
      setForm({ ...form, [name]: file });
      if (file) setPreview(URL.createObjectURL(file));
    } else {
      setForm({ ...form, [name]: e.target.value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formData = new FormData();
      Object.keys(form).forEach((key) => {
        if (form[key] !== null) {
          formData.append(key, form[key]);
        }
      });

      await axiosInstance.post(`/${endpoint}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert(successMessage || "Uploaded Successfully");

      // Reset form
      setForm(initial);
      setPreview(null);
    } catch (error) {
      console.log("UPLOAD ERROR:", error.response?.data || error);
      alert("Upload Failed");
    }

    setLoading(false);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: 450, marginBottom: 40 }}>
      {fields.map((f) => (
        <div key={f.name} style={{ marginBottom: 12 }}>
          <label>{f.label}</label>

          {f.type === "textarea" ? (
            <textarea
              value={form[f.name]}
              onChange={(e) => handleChange(e, f.name, f.type)}
              rows={3}
            />
          ) : (
            <input
              type={f.type}
              value={f.type !== "file" ? form[f.name] : undefined}
              onChange={(e) => handleChange(e, f.name, f.type)}
            />
          )}
        </div>
      ))}

      {preview && (
        <img
          src={preview}
          style={{
            width: 180,
            height: 180,
            objectFit: "cover",
            marginTop: 10,
          }}
        />
      )}

      <button type="submit" disabled={loading}>
        {loading ? "Uploading..." : "Upload"}
      </button>
    </form>
  );
}
